// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for react-datepicker to make available dates bold */

/* Make dates that are included (available) bold */
.react-datepicker__day:not(.react-datepicker__day--disabled):not(.react-datepicker__day--outside-month) {
  font-weight: bold;
}

/* Keep disabled dates normal weight */
.react-datepicker__day--disabled {
  font-weight: normal;
}

/* Make selected date extra bold */
.react-datepicker__day--selected {
  font-weight: 700;
}

/* Make keyboard selected date bold */
.react-datepicker__day--keyboard-selected {
  font-weight: bold;
}

/* Ensure today's date is also bold if it's available */
.react-datepicker__day--today:not(.react-datepicker__day--disabled) {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/styles/datepicker-custom.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE,kDAAkD;AAClD;EACE,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;AACnB","sourcesContent":["/* Custom styles for react-datepicker to make available dates bold */\n\n/* Make dates that are included (available) bold */\n.react-datepicker__day:not(.react-datepicker__day--disabled):not(.react-datepicker__day--outside-month) {\n  font-weight: bold;\n}\n\n/* Keep disabled dates normal weight */\n.react-datepicker__day--disabled {\n  font-weight: normal;\n}\n\n/* Make selected date extra bold */\n.react-datepicker__day--selected {\n  font-weight: 700;\n}\n\n/* Make keyboard selected date bold */\n.react-datepicker__day--keyboard-selected {\n  font-weight: bold;\n}\n\n/* Ensure today's date is also bold if it's available */\n.react-datepicker__day--today:not(.react-datepicker__day--disabled) {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
